// removed by extract-text-webpack-plugin
module.exports = {"legend":"legend__bT6Zo","textLabel":"textLabel__ziatK","exportLegend":"exportLegend__3DvgO","legendWrapper":"legendWrapper__377BM","legendColor":"legendColor__2TD5j","legendDescription":"legendDescription__2eQde","legendPercentage":"legendPercentage__2MeZr","perc":"perc__6qhZf","textField":"textField__3EZxZ","contributionText":"contributionText__xTi3a","dollor":"dollor__1j4FF","donut":"donut__3hpra","imageWrapper":"imageWrapper__1Z5ZS","sdg_image":"sdg_image__3-Q85","svgIe":"svgIe__1IjFl"};


//////////////////
// WEBPACK FOOTER
// ./components/donutChart/style.scss
// module id = XppB
// module chunks = 17